import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getPaymentMethodType, addPaymentMethodType, deletePaymentMethodType, updatePaymentMethodType } from "../../redux/actions/paymentMethodType.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess"
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Tooltip, Popconfirm, Modal, Divider } from 'antd';
import { CloseCircleOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { logColumns, paymentMethodTypeColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
const { TabPane } = Tabs;

export default function PaymentMethodType({ token }) {
    TabTitle("Payment Method Type")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const paymentMethodTypeNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm(); 
    const [paymentMethodTypeObj, setpaymentMethodTypeObj] = useState(null);
    const dispatch = useDispatch();
    const { paymentMethodType, getDemoDefaultCompany, companyAccess, companyAll, log, userRights } = useSelector(state => state)
    
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [paymentMethodTypeName, setpaymentMethodTypeName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

 


    useEffect(() => {
        dispatch(getPaymentMethodType(token, menuId));
        
        dispatch(getLog(token, { admin_payment_method_type: "admin_payment_method_type"}))
      }, [token]);
    

    
    
    


    useEffect(() => {
        dispatch(getPaymentMethodType(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (paymentMethodTypeObj) {
            setFormState('view')
            form.setFieldsValue({
                id: paymentMethodTypeObj.method_type_id,
                paymentMethodName: paymentMethodTypeObj.method_type_name,
                active: paymentMethodTypeObj.is_active
            });
            setpaymentMethodTypeName(paymentMethodTypeObj.method_type_name)
            setCheck(paymentMethodTypeObj.is_active)
            dispatch(getCompanyAccess(token, paymentMethodTypeObj.method_type_id, menuId))

        }
    }, [paymentMethodTypeObj]);

    useEffect(() => {
        if (paymentMethodTypeName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [paymentMethodTypeName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            
            dispatch(getLog(token, { admin_payment_method_type: "admin_payment_method_type"}))
        }
    }


    const formSave = () => {
        if (formState === "add") {
            dispatch(addPaymentMethodType(token, { paymentMethodTypeName, check }, menuId)).then((res) => {

                if (res.type === "ADD_PAYMENTMETHODTYPE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_PAYMENTMETHODTYPE_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    notification("success", "Payment Method Type Created", "PaymentMethod Type created successfully!");
                    form.setFieldsValue({
                        paymentMethodName: ""
                    })
                    setFormState("")
                    
                    setpaymentMethodTypeName("")
                    setpaymentMethodTypeObj(null)
                }
                dispatch(getPaymentMethodType(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updatePaymentMethodType(token, { paymentMethodTypeName, check }, paymentMethodTypeObj.method_type_id)).then((res) => {
                if (res.type === "UPDATE_PAYMENTMETHODTYPE_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_PAYMENTMETHODTYPE_SUCCESS") {
                    notification("success", "Payment Method Type Updated", "Record updated successfully")
                }
                dispatch(getPaymentMethodType(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (paymentMethodTypeObj) {
            dispatch(deletePaymentMethodType(token, paymentMethodTypeObj.method_type_id)).then((res) => {
                if (res.type === "DELETE_PAYMENTMETHODTYPE_SUCCESS") {
                    notification("success", "Payment Method Type Deleted", "Payment Method Type deleted successfully!");
                }
                if (res.type === "DELETE_PAYMENTMETHODTYPE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    paymentMethodName: ""
                })
                
                setpaymentMethodTypeName("")
                setpaymentMethodTypeObj(null)
                setFormState('')
                dispatch(getPaymentMethodType(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            paymentMethodTypeNameInput.current.focus();
            form.setFieldsValue({
                paymentMethodName: ""
            })
            setCheck(true)
            setpaymentMethodTypeName("")
            setpaymentMethodTypeObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Payment Method Type"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="paymentMethodType" paymentMethodTypeObj={setpaymentMethodTypeObj} scrollX={"20rem"} scroll={602} perPage={25} source={paymentMethodType?.payload?.data} col={paymentMethodTypeColumns} paginate load={paymentMethodType.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 12 }}
                                        >
                                             <div className='customRow styleFormUpper ' >
                                            {paymentMethodTypeObj !== null && !(formState === "add") &&
                                            <div className='customCols slc'>
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                    initialValue={form.getFieldValue().id}
                                                >
                                                    <Input  size='small' className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                                </div>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Type"
                                                name="paymentMethodName"
                                                labelCol={{ span: 12 }}
                                                wrapperCol={{ span: 14 }}
                                                initialValue={form.getFieldValue().paymentMethodName}
                                            >

                                                <Input  size='small' disabled={!(formState === "add" || formState === "edit")} ref={paymentMethodTypeNameInput} onChange={(e) => setpaymentMethodTypeName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                labelCol={{ span: 12 }}
                                                wrapperCol={{ span: 14 }}
                                                name="active"
                                            >
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
                                        </Form>
                                
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                         
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                   
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}